import React from 'react';
import { Button } from './ui/Button';
import { Link } from 'react-router-dom';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

export function PremiumPrompt() {
  return (
    <div className="bg-brand-premium-bg border border-brand-premium-border rounded-lg p-6 my-6 flex flex-col sm:flex-row items-center justify-between gap-4">
      <div>
        <h3 className="text-brand-red font-bold text-lg flex items-center gap-2">
          <SafeIcon icon={FiIcons.FiUnlock} />
          Desbloquea el Potencial Completo
        </h3>
        <p className="text-gray-700 mt-1">
          Obtén acceso a valoraciones detalladas, portafolios ilimitados y proyecciones a 10 años.
        </p>
      </div>
      <div className="flex flex-col items-center sm:items-end gap-3 w-full sm:w-auto">
        <Link to="/configuracion">
          <Button variant="primary" className="whitespace-nowrap shadow-sm w-full sm:w-auto">
            Actualizar a Premium
          </Button>
        </Link>
        <Link
          to="/configuracion"
          className="text-sm text-brand-red hover:underline text-center sm:text-right"
        >
          ¿Tienes un código Beta? Canjéalo en Configuración
        </Link>
      </div>
    </div>
  );
}